<ng-container *ngIf="displayConflictDescription(currentGroup)">
  <cx-icon [type]="iconTypes.WARNING"></cx-icon>
  {{ currentGroup.name }}
</ng-container>
